import "@testing-library/jest-dom";
import { fireEvent, render, screen } from "@testing-library/react";
import React from "react";
import SkillInvocationAttributionCard from "./SkillInvocationAttributionCard";

const sampleAttributions = [
  {
    id: 1,
    conversation_id: 42,
    turn_id: 101,
    tool_call_id: "call-1",
    skill_name: "gmail_recent_threads",
    started_at: "2026-04-21T10:00:00Z",
    duration_ms: 412,
    success: true,
    error: null,
    input_args: { limit: 5 },
    output_summary: "Found 5 recent threads.",
  },
];

test("renders and expands skill invocation attribution", () => {
  render(
    <SkillInvocationAttributionCard
      attributions={sampleAttributions}
      enabled
    />,
  );

  fireEvent.click(screen.getByRole("button", { name: /via skill/i }));

  const toggle = screen.getByTestId("skill-attribution-toggle");
  const panel = screen.getByTestId("skill-attribution-panel");

  expect(toggle).toBeInTheDocument();
  expect(toggle).toHaveAttribute("aria-expanded", "true");
  expect(toggle).toHaveAttribute("aria-controls", panel.id);
  expect(panel).toBeInTheDocument();
  expect(screen.getByText("gmail_recent_threads")).toBeInTheDocument();
  expect(screen.getByText(/Duration:/i)).toBeInTheDocument();
  expect(screen.getByText(/Found 5 recent threads\./i)).toBeInTheDocument();
  expect(screen.getByText(/"limit": 5/i)).toBeInTheDocument();
});

test("clicking the pill again collapses the attribution details", () => {
  render(
    <SkillInvocationAttributionCard
      attributions={sampleAttributions}
      enabled
    />,
  );

  const trigger = screen.getByRole("button", { name: /via skill/i });
  expect(trigger).toHaveAttribute("aria-expanded", "false");

  fireEvent.click(trigger);
  const panel = screen.getByTestId("skill-attribution-panel");
  expect(screen.getByText("gmail_recent_threads")).toBeInTheDocument();
  expect(trigger).toHaveAttribute("aria-expanded", "true");
  expect(trigger).toHaveAttribute("aria-controls", panel.id);
  expect(
    trigger.compareDocumentPosition(panel) & Node.DOCUMENT_POSITION_FOLLOWING,
  ).toBeTruthy();

  fireEvent.click(trigger);
  expect(trigger).toHaveAttribute("aria-expanded", "false");
  expect(trigger).not.toHaveAttribute("aria-controls");
  expect(screen.queryByText("gmail_recent_threads")).not.toBeInTheDocument();
});

test("aligns the attribution chip with its assistant message", () => {
  render(
    <SkillInvocationAttributionCard
      attributions={sampleAttributions}
      enabled
    />,
  );

  expect(screen.getByRole("button", { name: /via skill/i })).toHaveStyle({
    alignSelf: "flex-start",
  });
});

test("does not render when attribution flag is off", () => {
  const { container } = render(
    <SkillInvocationAttributionCard
      attributions={sampleAttributions}
      enabled={false}
    />,
  );

  expect(container).toBeEmptyDOMElement();
});

test("renders gate-blocked invocations as blocked instead of success", () => {
  render(
    <SkillInvocationAttributionCard
      enabled
      attributions={[
        {
          ...sampleAttributions[0],
          success: false,
          error: null,
          output_summary:
            "Life science sources are not enabled for this workspace.",
          result_status: "blocked",
        },
      ]}
    />,
  );

  fireEvent.click(screen.getByRole("button", { name: /via skill/i }));

  expect(screen.getByText("blocked")).toBeInTheDocument();
  expect(screen.getByText("Block reason")).toBeInTheDocument();
  expect(
    screen.getByText(/Life science sources are not enabled/i),
  ).toBeInTheDocument();
  expect(screen.queryByText("success")).not.toBeInTheDocument();
});
